export const MAX_OTHER_RECIPIENTS = 100;

export const OTHER_RECIPIENTS_EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export type OtherRecipientsInput = string | string[] | undefined | null;

export const parseOtherRecipients = (value: OtherRecipientsInput): string[] => {
  if (value == null) return [];
  if (Array.isArray(value)) {
    return [...new Set(value.map((v) => String(v).trim()).filter(Boolean))];
  }
  if (typeof value !== 'string') return [];
  const trimmed = value.trim();
  if (!trimmed) return [];
  return value
    .split(/[\s,]+/)
    .map((part) => part.trim())
    .filter(Boolean);
};

export const formatOtherRecipients = (addresses: string[]): string =>
  addresses.join(', ');

/** Normalize form value for the text input (yup may coerce to string[]). */
export const otherRecipientsToInputValue = (
  value: OtherRecipientsInput,
): string => {
  if (value == null) return '';
  if (Array.isArray(value)) return formatOtherRecipients(value);
  return typeof value === 'string' ? value : '';
};
